const filterCluster = (clusters, clusterType) => {
  return clusters
    .filter((cluster) => cluster.cluster === clusterType)
    .map(({ name, id }) => ({ name, id }));
};

export const useGroupClusters = (clusters) => {
  if (!clusters) return [];
  const clustersSet = new Set();
  clusters.forEach((cluster) => clustersSet.add(cluster.cluster));
  return Array.from(clustersSet)
    .sort()
    .map((cluster) => {
      return {
        label: `Cluster ${cluster}`,
        kinds: filterCluster(clusters, cluster),
      };
    });
};
